export const ALERTS_STATE_IS_LOADING = 'ALERTS_STATE_IS_LOADING';
